import React from 'react';

class ToggleButton extends React.Component {

  constructor( props ){
    super( props );
    this.state = {
      column: this.props.column === undefined ? '' : this.props.column,
      caption: this.props.caption === undefined ? '' : this.props.caption,
      readonly: this.props.readonly === undefined ? false : this.props.readonly,
      visible: this.props.visible === undefined ? true : this.props.visible,
      is_switched_on: this.props.is_switched_on === undefined ? false : this.props.is_switched_on,
      hasError: false,
      error: {},
      info: {}
    };

    this.onHandleClick = this.onHandleClick.bind( this ) ;
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  componentWillReceiveProps( nextProps ){
    this.setState( {
      column: nextProps.column === undefined ? '' : nextProps.column,
      caption: nextProps.caption === undefined ? '' : nextProps.caption,
      readonly: nextProps.readonly === undefined ? false : nextProps.readonly,
      visible: nextProps.visible === undefined ? true : nextProps.visible,
      is_switched_on: nextProps.is_switched_on === undefined ? false : nextProps.is_switched_on
    } );
  }

  onHandleClick( e ){

    if( this.state.readonly === true ) {
      return;
    }

    const newstate = !( ( ( this.state.is_switched_on === 'true' ) || ( this.state.is_switched_on === true ) ) ? true : false );

    this.setState( {
      is_switched_on: newstate
    } );

    if( this.props.onToggle !== undefined ) {
      e.target['column'] = this.state.column;
      this.props.onToggle( e, newstate );
    }
  }

  render(){

    const is_on = ( ( ( this.state.is_switched_on === 'true' ) || ( this.state.is_switched_on === true ) ) ? true : false );
    const caption = this.state.caption;

    let readonly = this.state.readonly;
    let opts = {};

    if( readonly === true ) {
      opts['readonly'] = 'readonly';
    }

    if( this.state.hasError === false ) {

      if( this.state.visible === false ) {
        return(
          <div></div>
        );
      } else {

        if ( is_on === true ) {

          return (
            <div className="toggle-button on" onClick={this.onHandleClick}>
              <div className="switch on" onClick={this.onHandleClick}></div>
              <span className="caption">{caption}</span>
            </div>
          );

        } else {

          return (
            <div className="toggle-button off" onClick={this.onHandleClick}>
              <div className="switch off" onClick={this.onHandleClick}></div>
              <span className="caption">{caption}</span>
            </div>
          );
        }
      }
    } else {
      return ( <span></span> );
    }
  }
}

export default ToggleButton;



// WEBPACK FOOTER //
// ./src/presentation/ToggleButton.js